module.exports = __webpack_public_path__ + "img/mem_two.f4b7e704.png";